import { Alert, AlertTitle, Flex, Text } from '@chakra-ui/react';
import { EnvConfig, type EnvNames, isProductionEnv } from '@ui/config/env';

export function EnvBanner() {
  if (isProductionEnv()) {
    return null;
  }

  const envName = EnvConfig.getKey('ENV_NAME');

  return (
    <Alert
      p={2}
      bgGradient="repeating-linear-gradient(-65deg, mw.orange, mw.orange 10px, mw.darkOrange 10px, mw.darkOrange 20px)"
      position="fixed"
      top={0}
      left={0}
      w="100%"
      zIndex={1000}
      transform="translateY(-90%)"
      transition="transform 0.2s cubic-bezier(0.25, 1, 0.5, 1)"
      filter={getHueRotation(envName)}
      _hover={{
        transform: 'translateY(0)',
        shadow: 'lg',
      }}
    >
      <Flex bg="white" rounded="full" py={1} px={4}>
        <AlertTitle fontSize={12} fontWeight="normal" m={0}>
          Environment:{' '}
          <Text fontWeight="bold" display="inline-block">
            {envName.toUpperCase()}
          </Text>
        </AlertTitle>
      </Flex>
    </Alert>
  );
}

function getHueRotation(envName: Omit<EnvNames, 'production'>) {
  switch (envName) {
    case 'staging':
      return 'hue-rotate(90deg)';
    case 'integration':
      return 'hue-rotate(180deg)';
    default:
      return 'none';
  }
}
